import script from "./ProductFeatureManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFeatureManager.vue?vue&type=script&setup=true&lang=js"

import "./ProductFeatureManager.vue?vue&type=style&index=0&id=13088bfc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13088bfc"]])

export default __exports__